import React, { useEffect } from "react";
import { FiX, FiCheckCircle, FiInfo, FiAlertCircle } from "react-icons/fi";

const Toast = ({ message, type = "success", onClose, duration = 3000 }) => {
	useEffect(() => {
		if (duration) {
			const timer = setTimeout(() => {
				onClose();
			}, duration);
			return () => clearTimeout(timer);
		}
	}, [duration, onClose]);

	const types = {
		success: {
			bg: "bg-green-500",
			icon: <FiCheckCircle size={20} />,
		},
		info: {
			bg: "bg-blue-500",
			icon: <FiInfo size={20} />,
		},
		warning: {
			bg: "bg-yellow-500",
			icon: <FiAlertCircle size={20} />,
		},
		error: {
			bg: "bg-red-500",
			icon: <FiAlertCircle size={20} />,
		},
	};

	const config = types[type] || types.info;

	return (
		<div
			className={`fixed top-20 right-4 z-50 ${config.bg} text-white px-6 py-4 rounded-xl shadow-2xl flex items-center gap-3 animate-slide-in-right max-w-md`}
			style={{
				animation: "slideInRight 0.3s ease-out",
			}}
		>
			{config.icon}
			<p className="flex-1 font-medium">{message}</p>
			<button
				onClick={onClose}
				className="hover:bg-white hover:bg-opacity-20 rounded-full p-1 transition-colors"
				aria-label="Close"
			>
				<FiX size={18} />
			</button>
		</div>
	);
};

export default Toast;

